<script setup>
const props = defineProps({
  score: Number,
  variant: {
    type: String,
    default: 'default',
    validator: (value) =>
      ['success', 'warning', 'danger', 'default'].includes(value)
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md'].includes(value)
  }
});

const classes = {
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-danger',
  default: 'bg-default/50'
}[props.variant];

const sizes = {
  md: 'p-4 text-2xl rounded',
  sm: 'p-3 text-lg rounded-xl'
}[props.size];
</script>

<template>
  <div class="font-bold text-white" :class="[classes, sizes]">
    <div class="flex items-baseline px-1 whitespace-nowrap">
      {{ score }}
      <span class="text-sm">/5</span>
    </div>
  </div>
</template>
